import React, { memo, useState } from 'react';
import SVG from 'react-inlinesvg';
import SupportConnectionDialogContainer from '../../containers/SupportConnectionDialogContainer';
import styles from './supportConnection.module.scss';

export default memo(function SupportConnection() {
    const [open, setOpen] = useState(false);

    const openDialog = () => setOpen(true);
    const closeDialog = () => setOpen(false);

    return (
        <>
            <div onClick={openDialog} className={styles.iconContainer}>
                <SVG cacheGetRequests className={styles.icon} src="./icons/life_vest.svg" />
            </div>
            {open && <SupportConnectionDialogContainer open={open} closeDialog={closeDialog} />}
        </>
    );
});
